ApplicationSerializer = require './application'

App.BusinessRoleSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    staff_members:
      serialize: 'ids'
